import { FieldMetaData } from "../../core/gb-api";

export function findMeta(name: string, meta: Object): FieldMetaData {
  if (!meta || !name) {
    return;
  }
  const names = name.split(".");
  const fieldname = names[names.length - 1];

  const metaFieldname =
    "m" + fieldname.substr(0, 1).toUpperCase() + fieldname.substr(1);

  return find(meta, names, metaFieldname, 0);
}

function find(meta, names, metaFieldname, index): FieldMetaData {
  let metaField = meta[metaFieldname];
  if (metaField) {
    return metaField;
  }
  const length = names.length;
  if (index > length - 1) {
    throw new Error("Metasuche: Index > Length - 1");
  }

  const name = names[index].substr(0, 1).toLowerCase() + names[index].substr(1);
  const submeta = meta[name];
  if (!submeta) {
    return null;
  }
  metaField = submeta[metaFieldname];
  if (metaField) {
    return metaField;
  }
  return find(submeta, names, metaFieldname, index + 1);
}

const metaPattern = /^m[A-Z].*/;

export function simplify<T>(o: any) {
  if (o instanceof Object) {
    const simplified = <T>{};
    let empty = true;
    for (const key in o) {
      if (!key.match(metaPattern)) {
        const simplifiedValue = simplify(o[key]);
        if (simplifiedValue !== null) {
          simplified[key] = simplifiedValue;
          empty = false;
        }
      }
    }
    return empty ? null : simplified;
  } else {
    if (o === "") {
      return null;
    }
    return o;
  }
}

export function copy(fromObject: object, toObject: object) {
  if (!fromObject) {
    return toObject;
  }
  const searchRequest = { ...toObject }; // clone object
  for (const key in fromObject) {
    if (fromObject.hasOwnProperty(key) && searchRequest.hasOwnProperty(key)) {
      if (
        fromObject[key] instanceof Object &&
        toObject[key] instanceof Object
      ) {
        searchRequest[key] = copy(fromObject[key], searchRequest[key]);
      } else {
        if (searchRequest[key] !== fromObject[key]) {
          searchRequest[key] = fromObject[key];
        }
      }
    }
  }
  return searchRequest;
}

export function copyMetaData(fromObject, toObject) {
  if (!fromObject) {
    return toObject;
  }
  const searchRequest = toObject;
  if ("access" in searchRequest && "identifier" in searchRequest) {
    return fromObject;
  } else {
    for (const key in fromObject) {
      if (fromObject.hasOwnProperty(key) && searchRequest.hasOwnProperty(key)) {
        if (
          fromObject[key] instanceof Object &&
          toObject[key] instanceof Object
        ) {
          searchRequest[key] = copyMetaData(
            fromObject[key],
            searchRequest[key]
          );
        }
      }
    }
    return searchRequest;
  }
}

export function onlyUnique(thing, index, array) {
  return (
    index ===
    array.findIndex((t) => JSON.stringify(t) === JSON.stringify(thing))
  );
}

export function concat(a: string, b: string, concatChar = " ") {
  if (a && b) {
    return a + concatChar + b;
  }
  if (a) {
    return a;
  }
  if (b) {
    return b;
  }
}

export function trimToNull(value: string): string {
  if (isBlankInputValue(value)) {
    return null;
  }

  return value.trim();
}

export function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  return value == null || value.length === 0;
}

export function isBlankInputValue(value: any): boolean {
  return value == null || value.trim().length === 0;
}
